import { gql } from "@apollo/client";

export const UPDATE_ASSIGNMENT_TERMS = gql`
  mutation UpdateAssignmentTerms(
    $token: String!
    $assignment_terms_input: AssignmentTermsInput!
  ) {
    updateAssignmentTerms(
      token: $token
      assignment_terms_input: $assignment_terms_input
    ) {
      id
      start_date
      end_date
      bill_rate_cents
    }
  }
`;
